import styled, { css } from 'styled-components';

import { IconButton, Chip as MuiChip } from '@mui/material';

export const CloseButton = styled(IconButton)`
  ${({ theme }) => css`
    svg {
      width: ${theme.spacing(3)};
      height: ${theme.spacing(3)};
      fill: ${theme.yoga.colors.primary};
    }
  `}
`;

export const Chip = styled(MuiChip)`
  cursor: pointer;
`;

export const WrapperButton = styled.div`
  display: flex;
  flex-direction: row;

  .MuiButtonBase-root {
    padding: ${({ theme }) => theme.yoga.spacing.zero};
  }

  .MuiSvgIcon-root {
    fill: ${({ theme }) => theme.yoga.colors.primary};
  }
`;
